export function events() {
    let textContainer = $('.events-info .description');
    let accordion = $('.accordion');
    let startInfo = accordion.find('li:first .hidden-info').html();
    textContainer.html(startInfo);
    accordion.find('h2 > a').on('click', function (e) {
        let $this = $(this);
        let parent = $this.closest('li');
        let description = parent.find('.hidden-info');
        let descriptionText = description.html();
        if (window.innerWidth >= 1200) {
            textContainer.removeClass('visible');
            setTimeout(function () {
                textContainer.addClass('visible');
            }, 200);
            textContainer.html(descriptionText);
        }

        if (parent.hasClass('active')) {
            parent.removeClass('active');
            description.slideUp();
        } else {
            parent.siblings('.active').removeClass('active').find('.hidden-info').slideUp();
            parent.addClass('active');
            description.slideDown();
        }
        e.preventDefault();
    });

    $(function () {
        $('input[name="dates"]').daterangepicker({
            startDate: moment(),
            endDate: moment().add(2, 'day')
        });
    });

}


// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/events.js